import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

/**
 *
 * Add the class `slim` to reduce the height of the `segmented-control`
 *
 * @class NvSegmentedControlComponent
 *
 */
@Component({
  selector: 'nv-segmented-control',
  template: require('./nv-segmented-control.component.html'),
  styles: [require('./nv-segmented-control.scss')],
  encapsulation: ViewEncapsulation.Emulated,
})
export class NvSegmentedControlComponent {
  /**
   *
   *
   * @type {string}
   * @memberof NvSegmentedControlComponent
   */
  @Input() selected: string;

  /**
   *
   *
   * @type {number}
   * @memberof NvSegmentedControlComponent
   */
  @Input() index: number;

  /**
   *
   * @deprecated
   * @type {string[]}
   * @memberof NvSegmentedControlComponent
   */
  @Input() options: string[];

  /**
   *
   *
   * @type {EventEmitter<number>}
   * @memberof NvSegmentedControlComponent
   */
  @Output() clicked: EventEmitter<number> = new EventEmitter<number>();

  ngOnInit() {
    if (this.selected !== undefined) {
      // tslint:disable-next-line:no-console
      console.warn('nv-segmented-control: Using `selected` is deprecated. Use `index` instead');
    }
  }
  // tslint:disable-next-line:no-unused-variable
  isSelected(opt: number): boolean {
    return opt === this.index;
  }
  handleClick(index: number) {
    this.clicked.emit(index);
  }
}
